/* eslint-disable max-lines */
import TimeUtils from './TimeUtils';

  // Función para truncar segundos y milisegundos de un timestamp
  const truncateTime = (timestamp) => {
    const date = new Date(Number(timestamp));
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()).getTime();
  };

export default class RouteUtils {
  static getItiCoords(data, position, intermediates?) {
    let coords = [];
    let lastCoords;
    let polyline = require('@mapbox/polyline');
    if (!data?.plan) {
      return [];
    }
    if (data?.plan?.itineraries.length <= 0) {
      return [];
    }

    for (let i = 0; i < data?.plan?.itineraries[position].legs.length; i++) {
      let arrayCoords = polyline.decode(data.plan.itineraries[position].legs[i].legGeometry.points);
      let jsonIn = {};

      let origin = this.getCoords(data.plan.from?.lat, data.plan.from?.lon);
      let destination = this.getCoords(data.plan.to?.lat, data.plan.to?.lon);
      jsonIn['origin'] = origin;
      jsonIn['destination'] = destination;

      let mode = data.plan.itineraries[position].legs[i].mode;
      jsonIn['mode'] = data.plan.itineraries[position].legs[i].mode;

      if (mode === 'BUS' || mode === 'METRO' || mode === 'TRANSIT') {
        jsonIn['intermediateStops'] = data.plan.itineraries[position].legs[i].intermediateStops;
      }

      jsonIn['coords'] = this.parseCoords(arrayCoords);
      //Añade a la polyline las coordenadas para unir legs
      if (i !== 0 && !intermediates) {
        jsonIn['coords'].unshift(lastCoords);
      }
      jsonIn['color'] = data.plan.itineraries[position].legs[i].routeColor
        ? '#' + data.plan.itineraries[position].legs[i].routeColor
        : '#0078B2';
      if (mode === 'WALK') {
        jsonIn['color'] = '#9B9B9B';
      } else if (mode === 'BICYCLE') {
        jsonIn['color'] = '#27BBF5';
      } else if (mode === 'CAR') {
        jsonIn['color'] = '#f6ff00';
      } /* else jsonIn['color'] = '#f12f33'; */
      coords.push(jsonIn as never);
      lastCoords = jsonIn['coords'][jsonIn['coords'].length - 1];
    }
    return coords;
  }

  static getRoutesInfo(data) {
    let group = [];
    if (!data?.plan) {
      return [];
    }

    for (let i = 0; i < data?.plan?.itineraries?.length; i++) {
      let colors = [];
      let dateStart = new Date(data.plan.itineraries[i].startTime);
      let dateEnd = new Date(data.plan.itineraries[i].endTime);
      let startTime = TimeUtils.getTime(dateStart);
      let endTime = TimeUtils.getTime(dateEnd);
      let jsonIn = {};
      if (
        data.plan.itineraries[i].fare !== null &&
        data.plan.itineraries[i].fare !== undefined &&
        data.plan.itineraries[i].fare.fare !== null &&
        data.plan.itineraries[i].fare.fare !== undefined &&
        data.plan.itineraries[i].fare.fare.regular !== null &&
        data.plan.itineraries[i].fare.fare.regular !== undefined &&
        data.plan.itineraries[i].fare.fare.regular.cents !== null &&
        data.plan.itineraries[i].fare.fare.regular.cents !== undefined
      ) {
        jsonIn['price'] = data.plan.itineraries[i].fare.fare.regular.cents / 100 + '€';
      } else {
        jsonIn['price'] = 0 + '€';
      }
      jsonIn['id'] = i;
      jsonIn['distance'] = 0.0;
      jsonIn['startTime'] = startTime;
      jsonIn['endTime'] = endTime;
      jsonIn['duration'] = Math.round((data.plan.itineraries[i].duration / 3600) * 60);
      let legs = JSON.parse(JSON.stringify(data.plan.itineraries[i].legs));

      let origin = this.getCoords(data.plan.from?.lat, data.plan.from?.lon);
      let destination = this.getCoords(data.plan.to?.lat, data.plan.to?.lon);
      jsonIn['origin'] = origin;
      jsonIn['destination'] = destination;

      for (let j = 0; j < legs.length; j++) {
        if (legs[j].routeColor !== undefined) {
          colors.push(('#' + legs[j].routeColor) as never);
        }
        if (legs[j].mode === 'WALK') {
          colors.push('#9B9B9B' as never);
        }
        if (legs[j].mode === 'BICYCLE') {
          colors.push('#27BBF5' as never);
        }
        if (legs[j].mode === 'CAR') {
          colors.push('#f6ff00' as never);
        }
        legs[j].id = j;
        if (j === legs.length - 1) {
          legs[j].last = true;
        } else {
          /* Comprueba si hay un transbordo */
          if (
            (legs[j].mode === 'BUS' || legs[j].mode === 'METRO' || legs[j].mode === 'TRANSIT') &&
            (legs[j + 1].mode === 'BUS' ||
              legs[j + 1].mode === 'METRO' ||
              legs[j + 1].mode === 'BUS')
          ) {
            legs[j].transhipment = true;
          }
        }
        startTime = TimeUtils.getTime(new Date(legs[j].startTime));
        endTime = TimeUtils.getTime(new Date(legs[j].endTime));
        legs[j].startTime = startTime;
        legs[j].endTime = endTime;
        legs[j].duration = Math.round((legs[j].duration / 3600) * 60);
        if (legs[j].duration === 0) legs[j].duration = 1;
        if (legs[j]?.distance && legs[j]?.distance !== undefined) {
          jsonIn['distance'] += legs[j].distance;
          legs[j].distance =
            legs[j].distance > 1000
              ? `${(legs[j].distance / 1000).toFixed(2)} Km`
              : `${legs[j].distance.toFixed(0)} m`;
        }
      }

      jsonIn['legs'] = legs;
      jsonIn['colors'] = colors;

      if (i === 0) jsonIn['suggested'] = true;
      group.push(jsonIn as never);
    }
    return group;
  }

  static parseCoords(coords) {
    let parsedCoords: Array<{ lat: any; lng: any }> = [];
    for (let i = 0; i < coords.length; i++) {
      parsedCoords.push({
        lat: coords[i][0],
        lng: coords[i][1],
      });
    }

    return parsedCoords;
  }

  static sortRoutes(data, key, order) {
    return data?.sort(function (a, b) {
      let x = a[key],
        y = b[key];
      switch (key) {
        case 'price':
          if (a[key]) {
            x = a[key];
          } else {
            x = 0;
          }

          if (b[key]) {
            y = b[key];
          } else {
            y = 0;
          }
          break;
        case 'duration':
          if (a['endTime']) {
            x = a['endTime'];
          } else {
            x = 0;
          }

          if (b['endTime']) {
            y = b['endTime'];
          } else {
            y = 0;
          }
          break;
        default:
          if (a[key]) {
            x = a[key];
          } else {
            x = 0;
          }

          if (b[key]) {
            y = b[key];
          } else {
            y = 0;
          }
          break;
      }

      if (order === 'asc') {
        return x < y ? -1 : x > y ? 1 : 0;
      } else if (order === 'desc') {
        return x > y ? -1 : x < y ? 1 : 0;
      } else {
        if (order === 'asc') {
          return x < y ? -1 : x > y ? 1 : 0;
        } else if (order === 'desc') {
          return x > y ? -1 : x < y ? 1 : 0;
        }
      }
      return data;
    });
  }

  static resultsSorter = (results, plannerOrder)=> {
    if (!Array.isArray(results) || results.length === 0) {
      return [];
    }

    // Clonar el arreglo original
    const sortedArr = [...results];
    if (plannerOrder === 'duration') {
      // console.log('plannerOrder:', plannerOrder);
      sortedArr.sort((a, b) => {
        // 1 - Ordenar por fecha de llegada (endTime sin segundos)
        const aEndTimeTruncated = truncateTime(a.endTime);
        const bEndTimeTruncated = truncateTime(b.endTime);
        const dateOrderDiff = aEndTimeTruncated - bEndTimeTruncated;
        if (dateOrderDiff !== 0) {
          return dateOrderDiff;
        }

        // 2 - Ordenar por duración (duration)
        const fasterOrderDiff = Number(a.duration) - Number(b.duration);
        if (fasterOrderDiff !== 0) {
          return fasterOrderDiff; // Si hay diferencia, retorna esta
        }

        // 3 - Ordenar por menos transbordos (transfers)
        const transferOrderDiff = Number(a.transfers) - Number(b.transfers);
        if (transferOrderDiff !== 0) {
          return transferOrderDiff; // Si hay diferencia, retorna esta
        }

        return 0; // Son iguales en todos los criterios
      });
    }

    if (plannerOrder === 'transfers') {
      sortedArr.sort((a, b) => {

        // 1 - Ordenar por menos transbordos (transfers)
        const transferOrderDiff = Number(a.transfers) - Number(b.transfers);
        if (transferOrderDiff !== 0) {
          return transferOrderDiff;
        }

        // 2 - Ordenar por fecha de llegada (endTime)
        const dateOrderDiff = Number(a.endTime) - Number(b.endTime);
        if (dateOrderDiff !== 0) {
          return dateOrderDiff;
        }

        // 3 - Ordenar por duración (duration)
        const fasterOrderDiff = Number(a.duration) - Number(b.duration);
        if (fasterOrderDiff !== 0) {
          return fasterOrderDiff;
        }

        return 0; // Son iguales en todos los criterios
      });
    }

    if (plannerOrder === 'walkTime') {
      sortedArr.sort((a, b) => {

        // 1 - Ordenar por caminar menos
        const walkTimeOrderDiff = Number(a.walkTime) - Number(b.walkTime);
        if (walkTimeOrderDiff !== 0) {
          return walkTimeOrderDiff;
        }

        // 2 - Ordenar por fecha de llegada
        const dateOrderDiff = Number(a.endTime) - Number(b.endTime);
        if (dateOrderDiff !== 0) {
          return dateOrderDiff;
        }

        // 3 - Ordenar por duración
        const fasterOrderDiff = Number(a.duration) - Number(b.duration);
        if (fasterOrderDiff !== 0) {
          return fasterOrderDiff;
        }

        // 4 - Ordenar por menos transbordos (transfers)
        const transferOrderDiff = Number(a.transfers) - Number(b.transfers);
        if (transferOrderDiff !== 0) {
          return transferOrderDiff;
        }

        return 0; // Son iguales en todos los criterios
      });
    }

    return sortedArr;
  };

  /* Función para comprobar qué itinerarios son del modo Walk y te los devuelve */
  static getWalkItineraries(itineraries) {
    let results = [] as any;
    for (let i = 0; i < itineraries?.length; i++) {
      let isWalk = true;
      let j = 0;
      while (j < itineraries[i].legs?.length && isWalk) {
        isWalk = itineraries[i].legs[j].mode === 'WALK';
        j = j + 1;
      }
      if (isWalk) results.push(itineraries[i]);
    }
    return results;
  }

  /* Función para comprobar qué itinerarios son de modo especificado y te los devuelve
    modes TRANSIT, WALK, CAR, BICYCLE...
  */
  static getModeItineraries(itineraries, modes) {
    let results = [] as any;
    for (let i = 0; i < itineraries?.length; i++) {
      let isMode = true;
      let j = 0;
      while (j < itineraries[i].legs?.length && isMode) {
        isMode =
          itineraries[i].legs[j].mode === 'WALK' || modes.includes(itineraries[i].legs[j].mode);
        j = j + 1;
      }
      if (isMode) results.push(itineraries[i]);
    }
    return results;
  }

  static getLength(data) {
    return data.plan.itineraries.length;
  }

  static getDistSquared(point1, point2) {
    let differenceX = point1.latitude - point2.latitude;
    let differenceY = point1.longitude - point2.longitude;
    return differenceX * differenceX + differenceY * differenceY;
  }

  static getClosestToStop(position, coords) {
    let closest = coords[0];
    let shortestDistance = this.getDistSquared(position, coords[0]);
    for (let i = 0; i < coords.length; i++) {
      let d = this.getDistSquared(position, coords[i]);
      if (d < shortestDistance) {
        closest = coords[i];
        shortestDistance = d;
      }
    }
    return closest;
  }

  static getClosesIndextToStop(position, coords) {
    let closest = 0;
    let shortestDistance = this.getDistSquared(position, coords[0]);
    for (let i = 0; i < coords.length; i++) {
      let d = this.getDistSquared(position, coords[i]);
      if (d < shortestDistance) {
        closest = i;
        shortestDistance = d;
      }
    }
    return closest;
  }

  static getCoords(lat, lon) {
    if (!lat || !lon) return null;

    return {
      latitude: parseFloat(parseFloat(lat).toFixed(6)),
      longitude: parseFloat(parseFloat(lon).toFixed(6)),
    };
  }

  static isTransportPublicMode(mode: string) {
    if (
      mode === 'BUS' ||
      mode === 'RAIL' ||
      mode === 'SUBWAY' ||
      mode === 'TRANSIT' ||
      mode === 'TRAM' ||
      mode === 'FUNICULAR'
    ) {
      return true;
    }

    return false;
  }
  /**
   * @function getMeanSpeed devuelve los metros por segundos recorridos
   * en un array de distintas posiciones, el @param timeout debe
   * estar en segundos y ser igual a los segundos transcurridos entre la obtención
   * de cada posición del @param positions
   */
}
